
export default {
  methods: {
    print() {
      let conteudo =
        "<img onload='window.print();window.close()' src='http://vendas.flexcard.org.br/img/contrato_termos_adesao.823fd8ec.jpg'>";

      let tela_impressao = window.open("about:blank");
      tela_impressao.document.write(conteudo);
    }
  }
};
